import React, { useState } from "react";

interface AudioPickerProps {
  onValidAudioSelected: (file: File) => void;
}

const AudioPicker: React.FC<AudioPickerProps> = ({ onValidAudioSelected }) => {
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleAudioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;

    if (file) {
      // More lenient file type validation - accept any audio file or files ending with .mp3
      const isValidAudio = file.type.startsWith("audio/") ||
                          file.name.toLowerCase().endsWith(".mp3") ||
                          file.type === "audio/mpeg";

      if (!isValidAudio) {
        setValidationMessage("Only MP3 and audio files are supported.");
      } else {
        setValidationMessage("");
        console.log("AudioPicker: Valid audio file selected", file.name, file.type);
        onValidAudioSelected(file);
      }
    }
  };

  return (
    <div>
      <input type="file" accept="audio/mpeg,.mp3" onChange={handleAudioChange} />
      {validationMessage && <p style={{ color: "red", marginTop: "5px", marginBottom: "0" }}>{validationMessage}</p>}
    </div>
  );
};

export default AudioPicker;
